// import axios from "axios";
// import { toast } from "react-toastify";

// const baseURL = process.env.REACT_APP_API_URL;

// const axiosInstance = axios.create({
//   baseURL,
// });

// axiosInstance.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

// axiosInstance.interceptors.request.use(
//   async (config) => {
//     try {
//       const user = JSON.parse(localStorage.getItem("user"));
//       const token = user?.access_token;
//       config.headers.Authorization = `Bearer ${token}`;
//     } catch (error) {
//       toast.error(error.message);
//     }
//     return config;
//   },
//   (error) => {
//     toast.error(error.message);
//     return Promise.reject(error);
//   }
// );
// axiosInstance.interceptors.response.use(
//   (response) => {
//     return response;
//   },
//   async (error) => {
//     console.log(error, "errorerror");
//     if (!error?.response?.status) {
//       toast.error(error?.message);
//     } else if (error?.response?.status === 401) {
//       localStorage.removeItem("user");
//     } else if (error?.response?.status === 422) {
//       let errorResponse = error.response.data.message;
//       for (const key in errorResponse) {
//         if (errorResponse.hasOwnProperty(key)) {
//           toast.error(errorResponse[key][0]);
//         }
//       }
//     } else if (error?.response?.status && error?.response?.data?.message) {
//       toast.error(error?.response?.data?.message);
//     } else {
//       toast.error(error?.message);
//     }
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;


import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import {showErrorToast} from "../../common/ToastMessage";

const baseURL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
    baseURL,
});

axiosInstance.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

axiosInstance.interceptors.request.use(
  async (config) => {
    try {
      const token = Cookies.get("jwt_authorization");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      toast.error(error.message);  
    }
    return config;
  },
  (error) => {
    toast.error(error.message);
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (!error?.response?.status) {
      toast.error(error?.message);
    } else if (error?.response?.status === 401) {
      Cookies.remove("jwt_authorization");
      showErrorToast('Please Login Again')
    } else if (error?.response?.status === 422) {
      let errorResponse = error.response.data.message;
      for (const key in errorResponse) {
        if (errorResponse.hasOwnProperty(key)) {
          toast.error(errorResponse[key][0]);
        }
      }
    } else if (error?.response?.status && error?.response?.data?.message) {
      toast.error(error?.response?.data?.message);
    } else {
      toast.error(error?.message);
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
